import { render, staticRenderFns } from "./BaseHeaderPage.vue?vue&type=template&id=8ae2508a&"
import script from "./BaseHeaderPage.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderPage.vue?vue&type=style&index=0&id=8ae2508a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports